import React from 'react';
import '../css/ContactHero.css';

const ContactHero = () => {
  return (
    <header className="gfi-contact-hero-banner">
      
      {/* Industrial Navy Color Tint Mask matching image 17.JPG */}
      <div className="gfi-contact-hero-overlay"></div>

      <div className="gfi-contact-hero-viewport">
        <div className="gfi-contact-hero-alignment">
          
          {/* CENTER ALIGNED BREADCRUMB TRACK */}
          <nav className="gfi-contact-breadcrumb">
            <span className="gfi-contact-bc-node">GROWTH ACADEMY</span>
            <span className="gfi-contact-bc-divider">&gt;</span>
            <span className="gfi-contact-bc-active">CONTACT</span>
          </nav>

          {/* ALL-CAPS WHITE BOLD TITLE */}
          <h1 className="gfi-contact-hero-title">
            CONTACT OUR CENTERS
          </h1>

        </div>
      </div>

    </header>
  );
};

export default ContactHero;